import { Injectable } from "@angular/core";
import { Http, RequestOptions, Headers } from "@angular/http";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { Config } from "src/app/config";
import { SERVERRESPONSERESULT } from "src/app/models/serverresponse";
import { ServerResponseLogin } from "src/app/models/serverresponse_login";
import { User } from "src/app/models/user";

@Injectable()
export class UserAuthService {
  private user: User;
  private token: string;

  constructor(private http: Http, private router: Router) {
    this.user = new User();
  }

  private fixUTF8(text: string): string {
    let output = "";
    let i = 0;
    let charCode = 0;

    while (i < text.length) {
      charCode = text.charCodeAt(i);

      if (charCode < 128) {
        output += String.fromCharCode(charCode);
        i++;
      } else if (charCode > 191 && charCode < 224) {
        output += String.fromCharCode(
          ((charCode & 31) << 6) | (text.charCodeAt(i + 1) & 63)
        );
        i += 2;
      } else {
        output += String.fromCharCode(
          ((charCode & 15) << 12) |
          ((text.charCodeAt(i + 1) & 63) << 6) |
          (text.charCodeAt(i + 2) & 63)
        );
        i += 3;
      }
    }

    return output;
  }

  private base64Decode(text: string): string {
    const map =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    let output = "";
    let a = 0;
    let b = 0;
    let c = 0;
    let d = 0;
    let e = 0;
    let f = 0;
    let g = 0;
    let i = 0;

    text = text.replace("-", "+");
    text = text.replace(/[^A-Za-z0-9\+\/\=]/g, "");
    const textLength = text.length;
    while (i < textLength) {
      d = i >= textLength ? 64 : map.indexOf(text.charAt(i));
      i++;
      e = i >= textLength ? 64 : map.indexOf(text.charAt(i));
      i++;
      f = i >= textLength ? 64 : map.indexOf(text.charAt(i));
      i++;
      g = i >= textLength ? 64 : map.indexOf(text.charAt(i));
      i++;

      a = (d << 2) | (e >> 4);
      b = ((e & 15) << 4) | (f >> 2);
      c = ((f & 3) << 6) | g;

      output += String.fromCharCode(a);
      if (f != 64) {
        output += String.fromCharCode(b);
      }
      if (g != 64) {
        output += String.fromCharCode(c);
      }
    }
    return this.fixUTF8(output);
  }

  private readUserFromToken(): boolean {
    let tokenParts = this.token.split(".");
    if (tokenParts.length != 3) {
      return false;
    }
    let payloadStr = this.base64Decode(tokenParts[1]);
    let payload: any;
    try {
      payload = JSON.parse(payloadStr);
      this.user.id = +payload.userid;
      this.user.email = payload.email;
      this.user.firstname = payload.firstname;
      this.user.lastname = payload.lastname;
    } catch (err) {
      console.error(err);
      return false;
    }
    return true;
  }

  login(email: string, password: string): Observable<ServerResponseLogin> {
    const headers: Headers = new Headers();
    headers.append("X-Requested-With", "XMLHttpRequest");
    const opts: RequestOptions = new RequestOptions();
    opts.headers = headers;
    const data = {
      opt: "login",
      email: email,
      password: password,
    };

    return this.http.post(Config.SERVER_API, data, opts).pipe(
      map(response => {
        try {
          let json = <ServerResponseLogin>response.json();
          if (json.result == SERVERRESPONSERESULT.OK) {
            this.token = json.token;
            localStorage.setItem("user_token", this.token);
            this.readUserFromToken();
          }
          return json;
        } catch (err) {
          console.error(err);
          let ret: ServerResponseLogin = {
            result: SERVERRESPONSERESULT.Error,
            error: "Server error",
          };
          return ret;
        }
      })
    );
  }

  logout(): void {
    localStorage.removeItem("user_token");
    this.token = "";
    this.user = new User();
  }

  checkLogin(): boolean {
    this.token = localStorage.getItem("user_token");
    if (this.token) {
      if (!this.readUserFromToken()) {
        this.logout();
        return false;
      }
      return true;
    }

    return false;
  }

  get currentUser(): User {
    return this.user;
  }

  get userToken(): string {
    if (this.token) {
      return this.token;
    }
    return "";
  }
}
